import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeNavItem: null,
    openId: '',
    cityCode: ''
  },
  mutations: {
    setActiveNavItem (state, route) {
      state.activeNavItem = route
    },
    SET_CITY_CODE (state, cityCode) {
      state.cityCode = cityCode
    },
    RESET_CITY_CODE (state) {
      state.cityCode = ''
    }
  },
  actions: {
    updateCityCode ({ commit }, cityCode) {
      commit('SET_CITY_CODE', cityCode)
    },
    resetCityCode ({ commit }) {
      commit('RESET_CITY_CODE')
    }
  },
  getters: {
    cityCode: (state) => state.cityCode
  },
  modules: {
  }
})
